import styles from './index.module.scss';
import React from 'react';
import { Modal, Empty } from '@maxtropy/components';
import { V2ElectricMapDataGgdDataPostResponse } from '@maxtropy/device-customer-apis-v2';
import { keepTwoOrLine, keepZeroOrLine } from '@/utils/utils';
import switchOnPng from '../../imgs/switch-on.png';
import switchOffPng from '../../imgs/switch-off.png';
import { Spin } from 'antd';

interface GgdLightModalProps {
  open: boolean;
  loading: boolean;
  title?: string;
  data?: V2ElectricMapDataGgdDataPostResponse;
  onClose: () => void;
  onToggleStatus: () => void;
}

const getModalContainer = () => document.getElementById('full_screen_box') ?? document.body;

const GgdLightModal: React.FC<GgdLightModalProps> = ({ open, loading, title, data, onClose, onToggleStatus }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={360}
      footer={null}
      title={data?.name ?? title ?? '高杆灯'}
      className={styles.lightModal}
      destroyOnClose
      getContainer={getModalContainer}
    >
      {loading ? (
        <div className={styles.lightModalState}>
          <Spin />
        </div>
      ) : data ? (
        <div className={styles.lightModalContent}>
          <div className={styles.lightRow}>
            <span className={styles.lightLabel}>状态：</span>
            {data.intStatus === 2 ? (
              <span className={styles.lightText}>离线</span>
            ) : (
              <img
                className={styles.lightSwitch}
                src={data.intStatus === 1 ? switchOnPng : switchOffPng}
                alt=""
                onClick={onToggleStatus}
              />
            )}
            <span className={styles.lightLabel}>功率：</span>
            <span className={styles.lightValue}>{keepTwoOrLine(data.power)}kW</span>
          </div>
          <div className={styles.lightRow}>
            <span className={styles.lightLabel}>温度：</span>
            <span className={styles.lightText}>{data.temperature ?? '--'}℃</span>
          </div>
          <div className={styles.lightRow}>
            <span className={styles.lightLabel}>A/B/C三相电压：</span>
            <span className={styles.phaseA}>{keepZeroOrLine(data.avoltage)}</span>
            <span className={styles.phaseSplit}>/</span>
            <span className={styles.phaseB}>{keepZeroOrLine(data.bvoltage)}</span>
            <span className={styles.phaseSplit}>/</span>
            <span className={styles.phaseC}>{keepZeroOrLine(data.cvoltage)}</span>
            <span className={styles.lightText}> V</span>
          </div>
          <div className={styles.lightRow}>
            <span className={styles.lightLabel}>A/B/C三相电流：</span>
            <span className={styles.phaseA}>{keepZeroOrLine(data.acurrent)}</span>
            <span className={styles.phaseSplit}>/</span>
            <span className={styles.phaseB}>{keepZeroOrLine(data.bcurrent)}</span>
            <span className={styles.phaseSplit}>/</span>
            <span className={styles.phaseC}>{keepZeroOrLine(data.ccurrent)}</span>
            <span className={styles.lightText}> A</span>
          </div>
        </div>
      ) : (
        <div className={styles.lightModalState}>
          <Empty description="暂无数据" />
        </div>
      )}
    </Modal>
  );
};

export default GgdLightModal;
